define(["exports", "text!../../assets/clipboard.svg"], function (_exports, _clipboard) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _clipboard = _interopRequireDefault(_clipboard);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
   * Module core/webidl-clipboard
   *
   * This module adds a button to each IDL pre making it possible to copy
   * well-formatted IDL to the clipboard.
   *
   */
  const name = "core/webidl-clipboard"; // This button serves a prototype that we clone as needed.

  _exports.name = name;
  const copyButton = document.createElement("button");
  copyButton.innerHTML = _clipboard.default;
  copyButton.title = "Copy IDL to clipboard";
  copyButton.classList.add("respec-button-copy-paste", "removeOnSave");

  async function run() {
    for (const pre of document.querySelectorAll("pre.idl")) {
      const button = copyButton.cloneNode(true);
      button.addEventListener("click", () => {
        clipboardWriteText(pre.textContent);
      });
      pre.prepend(button);
    }
  }
  /**
   * Mocks navigator.clipboard.writeText()
   * @param {string} text
   */


  function clipboardWriteText(text) {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(resolve => {
      document.addEventListener("copy", ev => {
        ev.clipboardData.setData("text/plain", text);
        resolve();
      }, {
        once: true
      });
      document.execCommand("copy");
    });
  }
});
//# sourceMappingURL=webidl-clipboard.js.map